import { useEffect } from 'react';
import PageHeader from '@/components/base/PageHeader';

export default function UeberUns() {
  useEffect(() => {
    document.title = 'Über uns | Druckerei Rahmede';
  }, []);

  return (
    <>
      <PageHeader
        label="Unser Unternehmen"
        title="Tradition, Qualität und persönlicher Service"
        subtitle="Als familiennaher Betrieb aus Schalksmühle-Heedfeld verbinden wir handwerkliche Präzision mit moderner Drucktechnik."
      />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-10 md:gap-14">
            <div className="w-full lg:w-1/2">
              <div className="w-full h-[300px] md:h-[480px] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20high%20quality%20printing%20craftsmanship%20elegant%20paper%20textures%20with%20subtle%20ink%20impressions%20warm%20natural%20lighting%20sophisticated%20artisanal%20industrial%20aesthetic%20soft%20focus%20background%20cream%20and%20terracotta%20tones%20editorial%20product%20photography&width=800&height=700&seq=about-detail-01&orientation=landscape"
                  alt="Hochwertige Druckerzeugnisse aus unserer Druckerei"
                  title="Druckerei Rahmede — Qualität und Handwerk"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="w-full lg:w-1/2">
              <div className="space-y-5 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  Seit vielen Jahren steht die Druckerei Rahmede für hochwertige Druckerzeugnisse und individuelle Lösungen. Als familiennaher Betrieb aus Schalksmühle-Heedfeld verbinden wir handwerkliche Präzision mit moderner Drucktechnik. Dabei legen wir besonderen Wert auf persönliche Beratung, Zuverlässigkeit und höchste Qualitätsstandards.
                </p>
                <p>
                  Gegründet als regionaler Druck- und Siebdruckbetrieb in Schalksmühle-Heedfeld, haben wir uns über die Jahre zu einem verlässlichen Partner für Unternehmen, Vereine, Behörden und Privatkunden entwickelt. Unsere Wurzeln in der Region sind uns wichtig — deshalb arbeiten wir bevorzugt mit lokalen Lieferanten zusammen und unterstützen damit die regionale Wirtschaft.
                </p>
                <p>
                  Ob kleine Auflagen oder größere Projekte — wir begleiten unsere Kunden von der ersten Idee bis zum fertigen Produkt. Dabei ist uns nicht nur das Ergebnis wichtig, sondern auch der Weg dorthin: Eine partnerschaftliche Zusammenarbeit, bei der Sie als Kunde stets im Mittelpunkt stehen.
                </p>
                <p>
                  Unsere Stärke liegt in der Kombination aus traditionellem Handwerk und modernster Drucktechnologie. Wir investieren kontinuierlich in unsere Maschinen und unser Know-how, um Ihnen stets die besten Ergebnisse zu liefern — bei gleichbleibend fairen Konditionen.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-8 md:gap-12 mt-14 md:mt-20 pt-10 md:pt-14 border-t border-background-200/70">
            <div className="text-center px-4">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">25+</span>
              <p className="text-sm text-foreground-500 mt-2">Jahre Erfahrung</p>
            </div>
            <div className="text-center px-4">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">500+</span>
              <p className="text-sm text-foreground-500 mt-2">Zufriedene Kunden</p>
            </div>
            <div className="text-center px-4">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">10.000+</span>
              <p className="text-sm text-foreground-500 mt-2">Abgeschlossene Aufträge</p>
            </div>
            <div className="text-center px-4">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">8</span>
              <p className="text-sm text-foreground-500 mt-2">Leistungsbereiche</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}